import React, { useEffect, useState } from "react";
import { Layout } from "@components/layout/Layout";
import { useNavigate } from "react-router-dom";
import { MAIN_PAGE } from "../../../constants";

export const Unsubscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [showPopup, setShowPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailFromUrl = params.get('email');
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    }
  }, []);

  const handleUnsubscribe = async () => {
    if (!email) {
      alert("Missing email");
      return;
    }

    setStatus('loading');

    try {
      const res = await fetch('/api/mail/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const result = await res.json();
      if (res.ok) {
        setStatus('success');
        setShowPopup(true); // показати popup
        setTimeout(() => navigate(MAIN_PAGE), 3000); // редірект
      } else {
        console.error(result);
        setStatus('error');
        setShowErrorPopup(true);
        setButtonsDisabled(true);
        setTimeout(() => {
          setButtonsDisabled(false);
        }, 60000); 
      }
    } catch (err) {
      console.error(err);
      setStatus('error');
      setShowErrorPopup(true);
      setButtonsDisabled(true);
      setTimeout(() => {
        setButtonsDisabled(false);
      }, 60000); 

    }
  };

  const handleKeepMe = () => {
    navigate(MAIN_PAGE);
  };

  useEffect(() => {
    document.body.classList.add("main-page");
    return () => {
      document.body.classList?.remove("main-page");
    };
  }, []);

  return (
    <Layout>
      <div className="basic-main unsubscribe-main">
        <div className="container">
          <div className="section">
            <div className="unsubscribe-img">
              <img className="img-top-left" src={require("@assets/images/main/graphic-element01.png")} alt="" />
              <img className="img-bottom-left" src={require("@assets/images/main/graphic-element04.png")} alt="" />
              <img className="img-top-right" src={require("@assets/images/main/graphic-element02.png")} alt="" />
              <img className="img-bottom-right" src={require("@assets/images/main/graphic-element03.png")} alt="" />
            </div>
            <div className="unsubscribe-title">
              <h1 style={{ textAlign: 'center', fontSize: '2.7em', marginBottom: '45px' }}>
                Do you really want <br /> to unsubscribe?
              </h1>
             
                <div className="buttons-hold">
                  <button className="basic-button" onClick={handleKeepMe}>No, keep me in</button>
                  <button
                    className="basic-button transparent-button"
                    onClick={handleUnsubscribe}
                    disabled={buttonsDisabled}
                  >
                    {status === 'loading' ? 'Unsubscribing...' : 'Yes, unsubscribe me'}
                  </button>
                </div>

            </div>
          </div>
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
  <div className={`popup-overlay ${showPopup ? 'show' : ''}`}>
    <div className="popup-success">
      ✅ You’ve been successfully unsubscribed.<br />Redirecting...
    </div>
  </div>
)}
{showErrorPopup && (
  <div className="popup-overlay show">
    <div className="popup-error">
      ❌ Something went wrong. Please try again.
      <button className="popup-close" onClick={() => setShowErrorPopup(false)}>✖</button>
    </div>
  </div>
)}

      <a className="scroll-btn" href="#wrapper"></a>
    </Layout>
  );
};

export default Unsubscribe;
